<template>
  <abstract-autocomplete
    v-model="localValue"
    :list-api="listApi"
    :multiple="multiple"
    :return-object="returnObject"
    :query-param="queryParam"
    :id-predicate-path="idPredicatePath"
    :show-validation="showValidation"
    :vid="vid"
    :rules="rules"
    :chips="chips"
    :clearable="clearable"
    :deletable-chips="deletableChips"
    :small-chips="smallChips"
    :outlined="outlined"
    :rounded="rounded"
    :dense="dense"
    :single-line="singleLine"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :selected-item-to-text="selectedItemToText"
    :item-value="itemValue"
    :preload-all-options="preloadAllOptions"
    :counter="counter"
    :search-debounce-time="searchDebounceTime"
    @change="$emit('change', $event)"
    @inputObject="$emit('inputObject', $event)"
  >
    <template v-slot:prepend-item>
      <slot name="prepend-item">
        <v-col><b>Id</b></v-col>
        <v-col><b>Numer licznika</b></v-col>
        <v-col><b>Lokalizacja</b></v-col>
        <v-col><b>Model</b></v-col>
        <v-col><b>Numer sklepu</b></v-col>
        <v-col><b>Mikroserwer</b></v-col>
        <v-col><b>Klient</b></v-col>
      </slot>
    </template>
    <template v-slot:item="{ data }">
      <slot name="item" :data="data">
        <v-col>{{ data.item.id }}</v-col>
        <v-col>{{ data.item.meterNumber }}</v-col>
        <v-col>{{ data.item.location }}</v-col>
        <v-col>{{ data.item.model }}</v-col>
        <v-col>{{ data.item.storeNumber }}</v-col>
        <v-col>{{ data.item.dataLoggerIdentifier }}</v-col>
        <v-col>{{ data.item.customer }}</v-col>
      </slot>
    </template>
  </abstract-autocomplete>
</template>

<script>
import LocalValueInput from '@/general/component/form/autocomplete/abstract/LocalValueInput';
import AutocompleteProps from '@/general/component/form/autocomplete/abstract/AutocompleteProps';
import AbstractAutocomplete
  from '@/general/component/form/autocomplete/abstract/AbstractAutocomplete';
import { meterApi, MeterApi } from '@/context/meter/api/MeterApi';
import { dataLoggerApi } from '@/context/data_logger/api/DataLoggerApi';

export default {
  components: { AbstractAutocomplete },
  mixins: [LocalValueInput, AutocompleteProps],
  props: {
    value: {
      type: [Number, Object, Array],
      default: null
    },
    queryParam: {
      type: String,
      default: ''
    },
    idPredicatePath: {
      type: String,
      default: 'id'
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    preloadAllOptions: {
      type: Boolean,
      default: true
    },
    vid: {
      type: String,
      default: 'licznik'
    },
    label: {
      type: String,
      default: 'Licznik'
    },
    placeholder: {
      type: String,
      default: 'Wybierz licznik'
    },
    selectedItemToText: {
      type: Function,
      default: item => item.meterNumber
    },
    // listApi: {
    //   type: Function,
    //   default: MeterApi.findAutocomplete
    // }
  },
  methods: {
    c: console.log,
    async listApi(search, params) {
      return await meterApi.autocomplete(search, params);
    }
  }
};
</script>

<style scoped></style>
